import { Component, input } from '@angular/core';
import { OtcProductComponent } from '../../elements/otc-product/otc-product.component';
import { TElasticItemClient } from '@chemist2u/types-client/C2U/Elastic/default';

@Component({
    selector: 'app-product-grid',
    templateUrl: './product-grid.component.html',
    styleUrls: ['./product-grid.component.scss'],
    imports: [OtcProductComponent]
})
export class ProductGridComponent {
  public products = input.required<TElasticItemClient[]>();
  public xPadding = input<boolean>(false);
}